import { render } from "./BubbleRule5.vue?vue&type=template&id=69fdab56&scoped=true"
import script from "./BubbleRule5.vue?vue&type=script&lang=js"
export * from "./BubbleRule5.vue?vue&type=script&lang=js"

import "./BubbleRule5.vue?vue&type=style&index=0&id=69fdab56&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69fdab56"]])

export default __exports__